// extracted by mini-css-extract-plugin
export default {"container":"featured_container__HY5gc","error":"featured_error__g1PSG","notification":"featured_notification__AzPiI","image":"featured_image__pUW6T"};